import { render, staticRenderFns } from "./Profile4User.vue?vue&type=template&id=21c89efc&scoped=true&"
import script from "./Profile4User.vue?vue&type=script&lang=js&"
export * from "./Profile4User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c89efc",
  null
  
)

export default component.exports